<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="item.email">
      <v-form ref="form" v-model="validForm" autocomplete="off" role="presentation">
        <v-container grid-list-md>
          <v-layout wrap>


            <v-flex xs12 sm12 md12>
              <v-text-field
                :readonly="readonly"
                label="Company Name"
                v-model="item.name"
                :rules="validators.company.name"
              ></v-text-field>
            </v-flex>

         
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!validForm"
          @click="save()"
          v-if="$can('upsert', 'company')"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/company";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    item : {},
    value: false
  },
  data() {
    return {
      validForm: true,
      validators
    };
  },
  mounted() {
  },
  watch: {
    value() {
      if (this.isNew) {
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New company" : (this.readonly ? 'Company details' : "Edit company" );
    },
    readonly() {
      return !this.$can('upsert', 'company');
    }
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then(data => {
        // const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
      });
    },
    close() {
       this.$emit('input', false)
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          const message = this.isNew ? "Company created correctly" : 
            "Company updated correctly";
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$root.$emit('updateCompanies', newItem);
        })
        .catch(e => {
          const mex = this.isNew ? "An Error occurred during the Company create. " : 
            "An Error occurred during the Company update. ";
          this.$store.dispatch("app/openSnackbar", {
            message: mex + e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
